import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastService } from 'src/app/shared/services/toast.service';
import { UserService } from 'src/app/shared/services/user.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {

  isProd = environment.production;
  isStaging = environment.isStaging;

  emailAddress?: string;
  sendingReset: boolean = false;

  constructor(
    private userService: UserService, 
    public router: Router, 
    private toastService: ToastService) { }

  ngOnInit() {
  }

  resetPassword() {

    this.sendingReset = true;
    this.userService.resetPassword({ emailAddress: this.emailAddress }).subscribe(() => {

      this.toastService.success("Password Reset Email Sent");
      this.router.navigateByUrl('/login');

      this.sendingReset = false;

    }, (error: any) => {

      var errorMessage = "Password Reset Failed";
      if (error.error !== null && error.error.message !== undefined) {
        errorMessage = error.error.message;
      }

      this.sendingReset = false;
      this.toastService.error(errorMessage);

    });
  }

}
